<section class="mobile-tournois-container">

  <h2 class="titre-mobile">Nos tournois JCC</h2>

  <div class="grille-ronds">

    <a *ngFor="let jeu of jeux" [href]="jeu.lien" target="_blank" class="rond-jeu">
      <div class="contenu-rond">
        <p class="intro">Participez à un tournois</p>
        <img [src]="jeu.logo" [alt]="jeu.nom" class="logo-mobile">
      </div>
    </a>

  </div>

</section>